import { EventsName } from '../constants'

export const invalidateGroupCommunitiesEventDispatch = () =>
  window.dispatchEvent(new CustomEvent(EventsName.INVALIDATE_GROUP_COMMUNITIES_QUERY))

export const invalidateGroupCommunitiesEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.INVALIDATE_GROUP_COMMUNITIES_QUERY, listener)

  return () => window.removeEventListener(EventsName.INVALIDATE_GROUP_COMMUNITIES_QUERY, listener)
}
